import api from "../../helpers/api";



export const getIndustries = (options) =>
  api.post("industries/search", {...options});

  export const getIndustry = industryId => api.get(`industries/${industryId}`);